import { toast } from "react-toastify";
import * as XLSX from "xlsx";

/**
 * Export filtered Environment COA report rows to .xlsx (direct download).
 * @param {Object} filteredSamples - keyed sample map from Export COA filters
 * @param {string} fileName - file name without extension
 */
export const exportCoaSamplesToExcel = (filteredSamples, fileName = "Environment_Reports_Export") => {
  try {
    const workbook = XLSX.utils.book_new();
    const sampleEntries = filteredSamples ? Object.values(filteredSamples) : [];
    const testNames = [...new Set(
      sampleEntries.flatMap((entry) => entry.tests.map((test) => test.test_name)),
    )];

    const worksheetData = sampleEntries.map((row) => [
      row.received_date,
      row.sample_id,
      row.sample_type,
      ...testNames.map((testName) => {
        const test = row.tests.find((t) => t.test_name === testName);
        return test ? test.test_result : "N/A";
      }),
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Received Date", "Sample Id", "Sample Type", ...testNames],
      ...worksheetData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
    toast.success("Excel file downloaded successfully!");
    return true;
  } catch (error) {
    toast.error("Failed to download the Excel file.");
    return false;
  }
};
